import { getNodeWithInfo } from '@/api/nodes';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialValues = null;
const useNodeStore = create()(immer(() => initialValues));
const { setState: set } = useNodeStore;

// actions
export const nodeActions = {
  init: async (pathwayId, caseId, nodeId) => {
    const { node, caseNode, params, isDefault, customModel } = await getNodeWithInfo(pathwayId, caseId, nodeId);

    set({ node, caseNode, params, customModel, isDefault });

    return { node, caseNode, params, customModel };
  },

  clear: () => set(initialValues, true),

  updateParams: async (params, isDefault) => {
    set({ params, isDefault });
  },
};

// selectors
export const useNodeParams = () => useNodeStore(store => store?.node?.params);
export const useCaseNodeParams = () => useNodeStore(store => store?.params);
export const useNode = () => useNodeStore(store => store?.node);
export const useCaseNode = () => useNodeStore(store => store?.caseNode);
export const useCustomModel = () => useNodeStore(store => store?.customModel);
export const useIsDefault = () => useNodeStore(store => store?.isDefault);

export default useNodeStore;
